import { useState } from 'react';

export const useRefresh = () => {
  const [lastRefresh, setLastRefresh] = useState(Date.now());

  const refresh = () => {
    setLastRefresh(Date.now());
  };

  return { refresh, lastRefresh };
};
